import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AccordionItem as ChakraAccordionItem, AccordionButton as ChakraAccordionButton, } from '@chakra-ui/react';
import { ThemeIconSizeVariable } from '@caspeco/casper-ui-library.base-ui.theme';
import { Icon, Icons } from '@caspeco/casper-ui-library.components.icon';
import { useAccordionVariant } from './accordionContext';
export const AccordionItem = ({ children, title, ...props }) => {
    const variant = useAccordionVariant();
    const getIcon = (isExpanded) => {
        if (variant === 'noBorder') {
            return isExpanded ? Icons.TreeViewCollapse : Icons.TreeViewExpand;
        }
        return isExpanded ? Icons.Collapse : Icons.Expand;
    };
    return (_jsx(ChakraAccordionItem, { ...props, children: ({ isExpanded }) => (_jsxs(_Fragment, { children: [_jsx("h3", { children: _jsxs(ChakraAccordionButton, { children: [title, _jsx(Icon, { icon: getIcon(isExpanded), size: ThemeIconSizeVariable.Small })] }) }), children] })) }));
};
//# sourceMappingURL=accordionItem.js.map